import React from 'react';
import { number, string, bool } from 'prop-types';
import FormatPercentage from './FormatPercentage';
import { Text } from '../Ajaib';

const FormatHistoricalReturnPercentage = ({
  historicalReturn,
  textSize,
  bold,
}) => {
  const formattedHistoricalReturn = Number((historicalReturn * 100).toFixed(2));
  let textProps = null;
  let prefix = null;
  if (formattedHistoricalReturn === 0.0) {
    textProps = {};
    prefix = '';
  } else if (formattedHistoricalReturn > 0.0) {
    textProps = { positive: true };
    prefix = '+ ';
  } else {
    textProps = { negative: true };
    prefix = '- ';
  }

  return (
    <Text {...textProps} size={textSize} bold={bold}>
      {prefix}
      <FormatPercentage value={Math.abs(formattedHistoricalReturn)} />
    </Text>
  );
};

FormatHistoricalReturnPercentage.propTypes = {
  historicalReturn: number,
  textSize: string,
  bold: bool,
};

FormatHistoricalReturnPercentage.defaultProps = {
  historicalReturn: 0,
  textSize: 'body-bold',
  bold: false,
};

export default FormatHistoricalReturnPercentage;
